import * as types from "./actionTypes";
import initialState from "../../../reducers/initialState";

export default function folderVisibilityReducer(state = initialState.folderVisible, action) {
  switch (action.type) {
    case types.LOAD_FOLDER_USER_PREFERENCES_SUCCESS:
    case types.UPDATE_FOLDER_USER_PREFERENCES_SUCCESS:
      return { ...state, userPreferences: Object.assign([], action.payload, { isLoaded: true }) };
    case types.LOAD_FOLDER_SELECTED_USER_PREFERENCE_SUCCESS:
    case types.UPDATE_FOLDER_SELECTED_USER_PREFERENCE_SUCCESS:
      return { ...state, selectedUserPreference: { ...action.payload, isLoaded: true } };
    case types.LOAD_FOLDER_DEFAULT_USER_PREFERENCE_SUCCESS:
      return { ...state, defaultUserPreference: { ...action.payload, isLoaded: true } };
    default:
      return state;
  }
}
